import { Component } from '@angular/core';
import { UtilService } from '../../core/service/util.service';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent {
  constructor(
    public _util: UtilService
  ) { }

}
